import { SxProps, Theme } from '@mui/material';

export const accordionStyle: SxProps<Theme> = {
  border: 'none',
  boxShadow: 'none',
  borderRadius: 0,
  width: '100%',
  maxWidth: '100%',
  margin: 0,
  overflow: 'hidden',
  boxSizing: 'border-box',
  paddingLeft: 1,
  paddingRight: 1,
  '&:before': {
    display: 'none',
  },
  '&:first-of-type': {
    borderRadius: 0,
  },
  '&:last-of-type': {
    borderRadius: 0,
  },
};

export const scrollbarStyle: SxProps<Theme> = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '-ms-overflow-style': 'none',
  'scrollbar-width': 'none',
};
